export default "__VITE_ASSET__K$fnilvp__"